import React, { useState } from "react";
import Icon from "components/MainApp/atoms/Icon/icon";
import CopyIcon from "assets/images/copy.png";

import { copyToClipboard } from "helpers/utils/copy";

import styles from "./CredentialsBoxes.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const CredentialBoxes = ({ app, copyClient = false }) => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  return (
    <div className={styles["credentials-wrap"]}>
      <div className={styles["credential"]}>
        <div className={styles["title-credential"]}>{capitalize(i18n.t("client.id"))}</div>
        <div className={styles["value-credential"]}>
          <p className={styles["value"]}>{app.client_id}</p>

          {!copyClient && (
            <div className={styles["buttons-credentials"]}>
              <div
                className={styles["icon"]}
                onClick={() => copyToClipboard(app.client_id)}
              >
                <img src={CopyIcon} />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles["credential"]}>
        <div className={styles["title-credential"]}>{capitalize(i18n.t("secret.client"))}</div>
        <div className={styles["value-credential"]}>
          <p className={styles["value"]}>
            {visible
              ? app.client_secret
              : "**********************************"}
          </p>

          <div className={styles["buttons-credentials"]}>
            <div
              className={styles["icon"]}
              onClick={() => copyToClipboard(app.client_secret)}
            >
              <img src={CopyIcon} />
            </div>
            <i
              onClick={toggleVisibility}
              className={`icon-ojo ${styles["icon-ojo"]} ${styles["visibility-icon"]}`}
            ></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CredentialBoxes;
